import { Card, List, message } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import shallow from 'zustand/shallow';

import { GridList, GridListCardCover } from '../../components/GridList';
import { useTemplatesStore } from '../../stores';
import { Page } from '../components/Page';
import { CREATE_CAMPAIGN_ROUTE } from '../routes';

const { Meta } = Card;
const { Item } = List;

export function TemplatesPage() {
  const { t } = useTranslation();
  const history = useHistory();

  const {
    templates: { listTemplates },
    fetchTemplates,
  } = useTemplatesStore(({ templates, fetchTemplates }) => ({ templates, fetchTemplates }), shallow);

  const [{ loading, error }, fetchTemplatesAction] = useAsyncFn(fetchTemplates);

  React.useEffect(() => {
    (!listTemplates || (listTemplates && !listTemplates.items)) && fetchTemplatesAction();
  }, [fetchTemplatesAction, listTemplates]);

  React.useEffect(() => {
    if (error) message.error(error.message);
  }, [error]);

  const handleCardClick = <T extends object | null>(selectedTemplate: T) => () => {
    history.push(CREATE_CAMPAIGN_ROUTE, { selectedTemplate });
  };

  return (
    <Page title={t('TEMPLATES') as string}>
      <GridList
        data={(listTemplates && listTemplates.items) || []}
        loading={loading}
        loadMore={!!(listTemplates && listTemplates.nextToken)}
        onLoadMore={fetchTemplatesAction}
        renderItem={(item) => (
          <Item>
            <Card
              hoverable
              cover={<GridListCardCover src={item?.poster} alt={item?.name} />}
              onClick={handleCardClick(item)}
            >
              <Meta title={item?.name} />
            </Card>
          </Item>
        )}
      />
    </Page>
  );
}
